export default __webpack_public_path__ + "static/media/co_di.b2f27495.svg";